
<div class="user-input-rde">
  <div class="ws-label-section">{{ groupName }}</div>
  <RadioGroup
    v-model="multiSelectType"
    :items="[
      {
        label: 'User',
        value: 'user',
      },
      {
        label: 'Group User',
        value: 'group',
      },
    ]"
    @input="handleTypeChange"
  />
  <v-autocomplete
    v-if="multiSelectType === 'user'"
    v-model="values[mapFields]"
    :items="final_user_items"
    outlined
    dense
    small-chips
    multiple
    clearable
    deletable-chips
    class="app-g-autocomplete-v2"
    label="User"
    :rules="[validateRequired]"
  />

  <v-autocomplete
    v-if="multiSelectType === 'group'"
    v-model="selectedUserGroups"
    :items="user_group_items"
    itemText="name"
    itemValue="members"
    outlined
    dense
    small-chips
    multiple
    clearable
    deletable-chips
    class="app-g-autocomplete-v2"
    label="Group User"
    :rules="[validateRequired]"
    @change="handleChangeGroup"
  />
</div>
